import { COMMISSION_DETAILS, GET_COMMISSION_LIST, GET_COMMISSION_MONTH_LIST, GET_COMMISSION_SORT_LIST, GET_SOGANDHNAMU_DETAILS, RESET_COMMISSION_DATA, STUDENT_ATTENDANCE } from "../actions/CommissionActions";

const initialState = { // initial states
    commissions: [],
    sogandhnamuDetails: null,
    holidayStatus: null,
    commissionDetails: [],
    studentAttendance: null,
    commissionMonth: [],
    commissionSort: [],
};

const CommissionReducer = function (state = initialState, action) {
    switch (action.type) {
      case GET_COMMISSION_LIST: { // save fetched commission data into state
        return { ...state, commissions: (action.payload.data)?action.payload.data:[] };
      }
      case RESET_COMMISSION_DATA: { // save dashboard data into state
        return { ...state, commissionMonth: [], commissions:[] };
      }
      case GET_COMMISSION_MONTH_LIST: { // save fetched commission month data into state
        return { ...state, commissionMonth: (action.payload.data)?action.payload.data:[] };
      }
      case GET_COMMISSION_SORT_LIST: { // save fetched commission sort data into state
        return { ...state, commissionSort: (action.payload.data)?action.payload.data:[] };
      }
      case COMMISSION_DETAILS: { // save fetched commission data into state
        return { ...state, commissionDetails: (action.payload.data)?action.payload.data:[] };
      }
      case STUDENT_ATTENDANCE: { // save fetched commission data into state
        return { ...state, studentAttendance: (action.payload.data)?action.payload.data:null };
      }
      case GET_SOGANDHNAMU_DETAILS: { // save fetched sogandhnamu details data into state
        return { ...state, sogandhnamuDetails: (action.payload.data.certificate_details)?action.payload.data.certificate_details: null,
          holidayStatus: action.payload.data.is_next_month_holiday_added === null ? null : action.payload.data.is_next_month_holiday_added };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default CommissionReducer;